var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8106 13.3457L9.72834 1.25977C9.18614 0.330078 7.81783 0.330078 7.27197 1.25977L0.193068 13.3457C-0.351795 14.2721 0.326844 15.4375 1.41893 15.4375H15.5834C16.6711 15.4375 17.3518 14.2754 16.8106 13.3457ZM7.70295 5.07812C7.70295 4.63818 8.05989 4.28125 8.49983 4.28125C8.93977 4.28125 9.2967 4.63984 9.2967 5.07812V9.32812C9.2967 9.76807 8.93977 10.125 8.52971 10.125C8.11965 10.125 7.70295 9.76973 7.70295 9.32812V5.07812ZM8.49983 13.3125C7.92342 13.3125 7.45592 12.845 7.45592 12.2686C7.45592 11.6922 7.92309 11.2247 8.49983 11.2247C9.07656 11.2247 9.54373 11.6922 9.54373 12.2686C9.54241 12.8443 9.07756 13.3125 8.49983 13.3125Z",
    fill: "#F04040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertStatus);
export default __webpack_public_path__ + "static/media/AlertStatus.ff291c9eafd3ae3ccd7f71decb3db4f3.svg";
export { ForwardRef as ReactComponent };